// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SetupInput-wrapper-kOpIzSCo05","date":"SetupInput-date-2r-5Lk-7MX","vsSelected":"SetupInput-vs__selected-2kKmN1W2H_","divider":"SetupInput-divider-1GxZCHui91"};